import classNames from 'classnames'
import { useTranslation } from 'next-i18next/pages'
import parse from 'html-react-parser'
import ContactCta from 'components/contact-cta/ContactCta'
import styles from './Settlement.module.scss'
import { Heading, Header } from '@boltenergy-be/design-system'

const Settlement = () => {
  // i18n
  const { t } = useTranslation(['settlement', 'faqIncreaseInstallment'])

  return (
    <main className={styles.settlement}>
      <Header
        title={parse(t('title', 'Een goed tarief, toch een<br />hoge jaarafrekening: <span>hoe kan dat?</span>'))}
        docked
        color="accent-soft"
        shape="s1"
      >
        <p>{parse(t('description'))}</p>
      </Header>

      <section className={classNames('section', styles.explanations)}>
        <div className="container">
          <div className="columns">
            <div className="column is-half">
              <div className={styles.card}>
                <Heading as="h2" variant="h3" serif>
                  {t('moreEnergyUsage.title', 'Je verbruikte meer energie dan ingeschat')}
                </Heading>
                <p>
                  {t(
                    'moreEnergyUsage.description',
                    'Als je de voorbije maanden een nieuw elektronisch toestel of huishoudelijk apparaat installeerde, is de kans groot dat jouw energieverbruik toenam. Een wasmachine, droger, elektrische wagen of jacuzzi bijvoorbeeld. Mogelijks trok er bij jouw thuis een nieuwe persoon in of was je zelf gewoon meer thuis door de coronacrisis. Deze zaken kunnen de stijging van jouw energieverbruik verklaren. Daarom passen we jouw voorschot aan aan dit verhoogde verbruik, zodat je bij je volgende jaarafrekening niet hoeft bij te betalen.'
                  )}
                </p>
              </div>
            </div>
            <div className="column is-half">
              <div className={styles.card}>
                <Heading as="h2" variant="h3" serif>
                  {t('poorlyEstimated.title', 'Jouw voorschot werd niet juist ingeschat')}
                </Heading>
                <p>
                  {t(
                    'poorlyEstimated.description',
                    'Jouw voorschot werd mogelijks niet juist ingeschat. Dat kan gebeuren. Als je je prijs berekende op onze website en zelf geen verbruik ingaf, werd jouw voorschot bepaald op basis van het gemiddelde verbruik van een Belgisch gezin. In dat geval wijkt jouw energieverbruik hier dus van af en ligt het hoger. Het kan ook zijn dat je een verbruik doorgaf dat geen betrekking had op het hele jaar. Indien je bijvoorbeeld de gegevens invoerde op basis van een afrekeningsfactuur van enkele maanden. Of je vulde per ongeluk je verbruik in in de foute eenheid en niet in KWh (bijvoorbeeld gas in m3 in plaats van in KWh). In dit geval moeten we jouw voorschot aanpassen aan jouw hoger verbruik en valt je afrekening hoger uit dan verwacht.'
                  )}
                </p>
              </div>
            </div>
            <div className="column is-half">
              <div className={styles.card}>
                <Heading as="h2" variant="h3" serif>
                  {t('incorrectIndexes.title', 'Jouw meterstanden werden niet juist opgenomen door de netbeheerder')}
                </Heading>
                <p>
                  {t(
                    'incorrectIndexes.description',
                    'Het lijkt er op dat de netbeheerder een fout heeft gemaakt bij het opnemen van jouw meterstanden. We raden je aan om de meterstanden op je afrekeningsfactuur te vergelijken met de cijfers op je teller. Indien deze niet overeenkomen, neem je best contact op met de netbeheerder. Op basis van de feedback kunnen wij jouw afrekening corrigeren.'
                  )}
                </p>
              </div>
            </div>
            <div className="column is-half">
              <div className={styles.card}>
                <Heading as="h2" variant="h3" serif>
                  {t('indexesBefore15.title', 'We ontvingen jouw meterstanden vóór de 15de van de maand')}
                </Heading>
                <p>
                  {t(
                    'indexesBefore15.description',
                    'Jouw meterstanden werden opgenomen vóór de 15de van de maand. Dat wil zeggen dat we geen rekening houden met het betaalde voorschot van die maand voor deze afrekening. Dit omdat je voorschot voor een volledige maand geldt. Je afrekening van volgend jaar zal wel rekening houden met deze betaalde maand.'
                  )}
                </p>
              </div>
            </div>
            <div className="column is-half">
              <div className={styles.card}>
                <Heading as="h2" variant="h3" serif>
                  {t('winter.title', 'Invloed van de wintermaanden')}
                </Heading>
                <p>
                  {t(
                    'winter.description',
                    'Als je in het begin van de winter klant bij ons werd en de netbeheerder ons jouw meterstanden doorgeeft in of tegen het einde van de winter, dan is de kans groot dat de som van jouw betaalde voorschotten niet voldoende is om jouw werkelijk verbruik te dekken. Dit komt omdat je meer energie verbruikt in de winter dan in de zomer. Jouw voorschot wordt berekend op jaarbasis waardoor dit wat te laag is in de winter en wat te hoog in de zomer. Je hoeft je dan geen zorgen te maken.'
                  )}
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <ContactCta
        title={t('faqIncreaseInstallment:contact.title', 'Wij staan voor je klaar!')}
        description={t(
          'faqIncreaseInstallment:contact.description',
          'Wij helpen jou graag en willen jouw persoonlijke situatie altijd samen bespreken. Aarzel niet om ons te contacteren.'
        )}
        hasDarkBg
      />
    </main>
  )
}

export default Settlement
